import React from 'react';
import MUIButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { isEmpty } from 'lodash';
import useStore from '../Store/Store';

const Button = ({
  onClick,
  style,
  text = 'Save',
  variant = 'contained',
  bg = 'filled',
  loading = false,
  startIcon = null,
  endIcon = null,
  fullWidth = false,
  disabled = false,
  props,
}) => {
  const width = useStore((state) => state.screenWidth);

  return (
    <MUIButton
      {...props}
      fullWidth={fullWidth}
      variant={variant}
      startIcon={width > 550 ? startIcon : null}
      endIcon={width > 550 ? endIcon : null}
      sx={{
        padding: width > 550 ? undefined : '16.5px 14px',
        borderRadius: 50,
        background: bg === 'filled' ? '#26786a' : '#fff',
        color: bg === 'filled' ? '#fff' : 'black',
        border: '0.2px solid grey',
        boxShadow: 'none',
        gap: 1,
        '&:hover': {
          background: bg === 'filled' ? '#339489' : '#fff',
          boxShadow: 'none',
        },
        fontSize: width > 860 ? '14px' : width > 550 && width < 860 ? '10px' : '12px',
        ...style,
      }}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : text}
    </MUIButton>
  );
};

export default Button;
